import { Input } from "antd";
import styled from "styled-components";
const { Search } = Input;

export const SearchInput = styled(Search)`
  width: 100%;
  margin-right: 8px;
`;

export const SearchPanel = styled.div`
  width: 100%;
  display: flex;
`;
